import { useProfilesManaged } from "@lens-protocol/react-web";
import { useAccount as useWagmiAccount } from "wagmi";

const defaultMessage = "find the people who you have the most in common with";

interface Props {
  farcasterError?: string;
}
export function LoginPageMessage({ farcasterError }: Props) {
  const { address } = useWagmiAccount();

  return (
    <p className="text-[36px] text-white">
      {farcasterError ? (
        farcasterError
      ) : address ? (
        <Web3ConnectedMessage owner={address} />
      ) : (
        defaultMessage
      )}
    </p>
  );
}

export function Web3ConnectedMessage({ owner }: { owner: string }) {
  const { data: profiles, loading } = useProfilesManaged({
    for: owner,
    includeOwned: true,
  });

  if (!loading && profiles?.length === 0) {
    return <>the connected wallet doesn’t have a Lens account</>;
  }

  if (!profiles) {
    return <>{defaultMessage}</>;
  }

  if (profiles.length === 1) {
    return <>{defaultMessage}</>;
  }

  return <>select a Lens profile to login with</>;
}
